<template>
  <header style="position: relative">
    <div class="header-search">
      <img
        @click="goHome()"
        class="header-image"
        src="../assets/shangbiao.png"
        width="330"
        height="65"
        alt=""
      />
      <input
        class="header-search-input"
        type="text"
        :placeholder="$t('请输入关键字')"
        v-model="searchKw"
        @keyup.enter="search()"
        clearable
      />
      <i class="el-icon-search header-search-btn" @click="search()">{{
        $t("查询")
      }}</i>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  //   created() {

  //   },
  mounted() {
    this.getGs();
  },
  data() {
    return {
      searchKw: "",
      logourl: "",
      gsinfo: {},
      islogo: false,
    };
  },
  methods: {
    goHome() {
      this.$emit("search", "");
    },
    async getGs() {
      const backData = await this.$API.HKAPI({
        type: "getgsxx",
      });
      if (backData.data.gsbh) {
        this.gsinfo = backData.data;
        if (backData.data.pic > 0) {
          this.islogo = true;
          this.logourl = backData.data.tupianurl + "&id=" + backData.data.pic;
        }
      }
    },
    search() {
      this.$emit("search", this.searchKw);
    },
  },
   
};
</script>

<style scope lang="less">
.header-image {
  // position: absolute;
  // left: 15%;
  // top: 50%;
  // transform: translateY(-50%);
}

.header-search {
  height: 70px;
  margin: 0 auto;
  text-align: center;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  .header-search-input {
    border: 2px solid #ef1f1f;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    width: 40%;
    height: 40px;
    padding-left: 2%;
    box-sizing: border-box;
  }

  .header-search-input:focus {
    outline: none;
    border-color: #ef1f1f;
  }

  .header-search-btn {
    background-color: #ef1f1f;
    color: #fff;
    width: 120px;
    height: 40px;
    line-height: 40px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border: 2px solid #ef1f1f;
    box-sizing: border-box;
    margin-left: -1px;
    font-size: 16px;
  }

  .header-search-btn:hover {
    cursor: pointer;
    background-color: #d41c1c;
  }
}
</style>